import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IUser } from 'src/interfaces/user.interface';
import { UserModel } from 'src/models/user.model';
import { ConnectionService } from '../connection/connection.service';

@Injectable({
  providedIn: 'root',
})
export class LoginRepository {
  constructor(private conn: ConnectionService) {}

  public async login(user_data:any): Promise<UserModel> {
    const res = await this.conn.post(`${environment.URL_SERVER}/login`, user_data);
    return UserModel.fromJson(res as IUser)
  }
}
